import { PageContainer } from '@ant-design/pro-layout'
import { Tabs } from 'antd'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'

import InvoiceSearchPanel from '@/components/InvoiceSearchPanel'

import TaxReportTab from './TaxReportTab'

const getTodayRange = () => {
  const start = moment().startOf('day').seconds(0).milliseconds(0)
  const end = moment().endOf('day').seconds(0).milliseconds(0)
  return {
    startedAt: start.toISOString(),
    endedAt: end.toISOString(),
  }
}

export default function TaxInvoiceReports() {
  const { t } = useTranslation()
  const defaultDateRange = React.useMemo(() => getTodayRange(), [])

  const [filters, setFilters] = React.useState({
    status: 'issued',
    orderSerial: undefined,
    invoiceNo: undefined,
    limit: 20,
    startedAt: defaultDateRange.startedAt,
    endedAt: defaultDateRange.endedAt,
    deviceId: undefined,
  })
  const [params, setParams] = React.useState(null)
  const [totals, setTotals] = React.useState({})

  const onSearch = () => {
    setTotals({})
    setParams({
      start: filters.startedAt,
      end: filters.endedAt,
      status: filters.status,
      orderSerial: filters.orderSerial,
      invoiceNo: filters.invoiceNo,
      deviceId: filters.deviceId,
      limit: filters.limit,
    })
  }

  const onReset = () => {
    setFilters({
      status: 'issued',
      orderSerial: undefined,
      invoiceNo: undefined,
      limit: 20,
      startedAt: defaultDateRange.startedAt,
      endedAt: defaultDateRange.endedAt,
    })
    setTotals({})
    setParams(null)
  }

  return (
    <PageContainer ghost header={{ title: t('page.taxInvoiceReports.title') }}>
      <InvoiceSearchPanel
        filters={filters}
        onChange={(patch) => setFilters((f) => ({ ...f, ...patch }))}
        onSearch={onSearch}
        onReset={onReset}
        searchDisabled={!filters.startedAt || !filters.endedAt}
        totalCount={totals.count}
        totalAmount={totals.amount}
      />

      {params && (
        <Tabs defaultActiveKey='abb' destroyInactiveTabPane onChange={() => setTotals({})}>
          <Tabs.TabPane tab={t('page.taxInvoiceReports.abb.tabName')} key='abb'>
            <TaxReportTab variant='abb' params={params} onTotalsChange={setTotals} />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('page.taxInvoiceReports.full.tabName')} key='full'>
            <TaxReportTab variant='full' params={params} onTotalsChange={setTotals} />
          </Tabs.TabPane>
        </Tabs>
      )}
    </PageContainer>
  )
}
